<template>
  <div id="menu">
    <ul>
      <li @click="top()" v-if="isLoggedIn">TOPへ</li>
      <li @click="profit()" v-if="isLoggedIn">価格表示設定</li>
      <li @click="toLogin()" v-if="!isLoggedIn">ログイン画面へ</li>
      <li @click="editUserAccount()" v-if="isLoggedIn">登録情報確認</li>
      <li @click="saveItemList()" v-if="isLoggedIn">商品情報保存リスト</li>
      <li @click="orderHistory()" v-if="isLoggedIn">ご注文履歴</li>
      <li @click="userManager()" v-if="isAdmin">ユーザー管理</li>
      <li @click="what()">mm/styleとは？</li>
      <li @click="rule()">利用規約</li>
      <li @click="viewQa()">よくある質問</li>
      <li @click="logout()" v-if="isLoggedIn">ログアウト</li>
    </ul>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../../utils/App'
import * as Api from '../../../utils/Api'

// Module
import {DC_URL, DC_STORAGE_KEY} from '../../../constants/App'
import {USER_TYPE} from '../../constants/TypeEc'

export default {
  name: 'Menu',
  components: {
  },
  props: {
  },
  data () {
    return {
      errorMessage: { text: '' },
      validateErrorMessages: {},
      user: ''
    }
  },
  watch: {
  },
  computed: {
    isAdmin: function () {
      return (this.user.userType === USER_TYPE.DC_ADMIN.code)
    },
    isLoggedIn: function () {
      return (this.user.userId !== undefined)
    }
  },
  methods: {
    top: function () {
      this.$router.push('/mmstyle/top')
    },
    toLogin: function () {
      this.$router.push('/mmstyle/login')
    },
    userManager: function () {
      this.$router.push({
        name: 'DcUserManageer'
      })
    },
    editUserAccount: function () {
      this.$router.push({
        name: 'UpdateUserConfirm'
      })
    },
    saveItemList: function () {
      this.$router.push({
        name: 'SaveItemList'
      })
    },
    orderHistory: function () {
      this.$router.push({
        name: 'OrderHistoryList'
      })
    },
    logout: function () {
      axios.post(DC_URL.TOP + '/logout', {}
      ).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
        } else {
          App.removeLocalStorage(DC_STORAGE_KEY.USER_INFO)
          App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
          App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
          this.$router.push('/mmstyle/login')
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    what: function () {
      this.$router.push('/mmstyle/what')
    },
    viewQa: function () {
      this.$router.push('/mmstyle/faq')
    },
    rule: function () {
      this.$router.push('/mmstyle/user/use-rule')
    },
    profit: function () {
      this.$router.push({
        name: 'DcProfitSetting'
      })
    }
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/dctop.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/Menu.vue